import { Component } from "react";

export interface Props {
    text: Record<string, string>;
    lang: string;
};

export default class Paragraph extends Component<Props> {
    constructor(props: Props) {
        super(props);
    }
    render() {
        return (
            <p>
                {this.props.text[this.props.lang]}
            </p>
        );
    }
}
